$('story-filters').addEvent('click:relay(a)', function () {
   $$('#story-filters a').removeClass('filter-option-active');
   this.addClass('filter-option-active');
});

$$('.filter-options .js-toggle-selected').addEvent('click', function (ev) {
   this.getNext('.filter-items').toggleClass('visible-mobile');
});
